// eslint-disable-next-line ish-custom-rules/ban-imports-file-pattern
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';
import { ProductsListComponent } from 'ish-shared/components/product/products-list/products-list.component';

@Component({
  selector: 'ish-cms-product-list-rest',
  templateUrl: './cms-product-list-rest.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ProductsListComponent],
})
export class CMSProductListRestComponent implements CMSComponent, OnChanges {
  private httpClient = inject(HttpClient);

  readonly pagelet = input.required<ContentPageletView>();

  productSKUs$: Observable<string[]>;

  ngOnChanges() {
    if (this.pagelet().hasParam('ProductsRestEndpoint')) {
      this.productSKUs$ = this.getProductSKUs$();
    }
  }

  private getProductSKUs$(): Observable<string[]> {
    return this.httpClient.get<unknown>(this.pagelet().stringParam('ProductsRestEndpoint')).pipe(
      map(data => {
        let skus: string[] = [];

        // if the REST response is not already an Array of SKUs
        // a given mapper function can be applied to the REST 'data' to map the data to an Array of SKUs
        const pagelet = this.pagelet();
        skus = pagelet.hasParam('ProductsRestResponseMapper')
          ? Function('data', `"use strict"; return ${pagelet.stringParam('ProductsRestResponseMapper')}`)(data)
          : data;

        // limit the number of rendered products
        const pageletValue = this.pagelet();
        if (pageletValue.hasParam('MaxNumberOfProducts')) {
          skus = skus.splice(0, pageletValue.numberParam('MaxNumberOfProducts'));
        }

        return skus;
      })
    );
  }
}
